import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "flag-filled",
  "use": "flag-filled-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"flag-filled\"><path d=\"M19.035 8.229c.533.15.965.72.965 1.27v1.002c0 .552-.428 1.12-.965 1.27L6 15.437v5.564A.997.997 0 0 1 5 22c-.552 0-1-.446-1-.999V3a.997.997 0 0 1 1-1c.552 0 1 .446 1 .999v1.563l13.035 3.667z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol